import React, { useEffect, useState } from "react";
import { Package, RotateCcw, MapPin, Wallet, ChevronRight, Loader2 } from "lucide-react";
import api from "../../services/api";
import { useAuth } from "../../context/AuthContext";

const StatCard = ({ icon: Icon, label, value, onClick }) => (
  <button onClick={onClick} className="text-left bg-[#10131A] rounded-2xl border border-[#1E232D] p-5 card-hover w-full">
    <div className="w-11 h-11 rounded-full bg-[#181C26] flex items-center justify-center mb-3">
      <Icon size={22} className="text-[#FF3B3B]" />
    </div>
    <div className="text-2xl font-black text-slate-50">{value}</div>
    <div className="text-[13px] text-slate-400">{label}</div>
  </button>
);

const DashboardSection = ({ setSection }) => {
  const { user } = useAuth();
  const [summary, setSummary] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/account/summary"), api.get("/orders")])
      .then(([s, o]) => { setSummary(s.data); setOrders(o.data.slice(0, 3)); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#FF3B3B]" size={32} /></div>;

  return (
    <div>
      <h1 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-2xl md:text-3xl mb-1">Bonjour {user?.name?.split(" ")[0]} !</h1>
      <p className="text-slate-400 mb-6">Bienvenue sur votre espace personnel KTSauto.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard icon={Package} label="Commandes" value={summary?.orders_count ?? 0} onClick={() => setSection("orders")} />
        <StatCard icon={RotateCcw} label="Retours" value={summary?.returns_count ?? 0} onClick={() => setSection("returns")} />
        <StatCard icon={MapPin} label="Adresses" value={summary?.addresses_count ?? 0} onClick={() => setSection("addresses")} />
        <StatCard icon={Wallet} label="Total dépensé" value={`${(summary?.total_spent ?? 0).toFixed(2).replace(".", ",")} €`} onClick={() => setSection("orders")} />
      </div>

      <div className="flex items-center justify-between mb-4">
        <h2 className="font-bold text-slate-50 text-xl">Commandes récentes</h2>
        <button onClick={() => setSection("orders")} className="text-[#FF3B3B] font-semibold hover:underline flex items-center gap-1 text-[14px]">Voir tout <ChevronRight size={16} /></button>
      </div>
      {orders.length === 0 ? (
        <div className="bg-[#10131A] rounded-2xl border border-[#1E232D] p-10 text-center text-slate-400">Aucune commande pour le moment.</div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="bg-[#10131A] rounded-2xl border border-[#1E232D] p-4 flex items-center justify-between">
              <div>
                <div className="font-bold text-slate-50">#{o.id.slice(0, 8).toUpperCase()}</div>
                <div className="text-[13px] text-slate-400">{o.items.length} article(s)</div>
              </div>
              <span className="bg-emerald-950/60 text-emerald-400 text-[13px] font-semibold px-3 py-1 rounded-full capitalize">{o.status}</span>
              <div className="font-black text-slate-50">{o.total.toFixed(2).replace(".", ",")} €</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardSection;
